import React from 'react';
import { CITY_SEARCH_FORM_FIELD_NAME_DEFAULT } from '@cp/entities/location';
import { useEventCallback } from '@cp/ds/src/hooks/useEventCallback';
import { useTrackEvent } from 'src/shared/tracking';
// FIXME: upper level import
import { CatalogEvents } from 'src/features/catalog';
import { FormFieldName, FormModel } from './form';
import { WatcherProps } from './watcher.interface';

export const FORM_FIELD_NAMES_TO_WATCH = [FormFieldName.Date, FormFieldName.Start, FormFieldName.End] as const;

export const Watcher: React.FC<WatcherProps> = (props) => {
  const { defaultCity, onChangeCity, form, submit, defaultValues } = props;
  const onChangeCityMemoized = useEventCallback(onChangeCity);
  const track = useTrackEvent();

  React.useEffect(() => {
    const city = form.getValues(CITY_SEARCH_FORM_FIELD_NAME_DEFAULT);

    if (defaultCity && defaultCity.id !== city?.id) {
      form.setValue(CITY_SEARCH_FORM_FIELD_NAME_DEFAULT, defaultCity);
    }
  }, [defaultCity, form]);

  React.useEffect(() => {
    const subscription = form.watch((values, info) => {
      if (info.type !== 'change') {
        return;
      }

      /**
       * City changes
       */
      const city = values[CITY_SEARCH_FORM_FIELD_NAME_DEFAULT] as FormModel[typeof CITY_SEARCH_FORM_FIELD_NAME_DEFAULT];

      if (info.name === CITY_SEARCH_FORM_FIELD_NAME_DEFAULT && city && defaultValues[CITY_SEARCH_FORM_FIELD_NAME_DEFAULT]?.id !== city.id) {
        onChangeCityMemoized?.(city);
      }

      /**
       * Filter changes
       */
      if (info.name === FormFieldName.Date && values[FormFieldName.Date] && !values[FormFieldName.AvailableOnly]) {
        form.setValue(FormFieldName.AvailableOnly, true);
        track(CatalogEvents.FilterDateChange());
      }

      if (info.name === FormFieldName.End && !values[FormFieldName.End]) {
        track(CatalogEvents.FilterTimeChange());
      }

      if (info.name === FormFieldName.AvailableOnly && values[FormFieldName.AvailableOnly]) {
        track(CatalogEvents.FilterTimeChange());
      }

      const isFilterChanged = FORM_FIELD_NAMES_TO_WATCH.find((fieldName) => values[fieldName] !== defaultValues[fieldName]);

      if (isFilterChanged) {
        submit();
      }
    });
    return () => subscription.unsubscribe();
  }, [defaultValues, form, onChangeCityMemoized, submit, track]);

  return null;
};
